import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import React from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import HowItWorksAndChoosePlanSection
  from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';

const WinAYachtHoliday = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-a-yacht-holiday`;

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win A Private Yacht Holiday Worth £100k"
        description="Enter our weekly draw for the chance to win 2 weeks for up to 14 people on your own private yacht in St Tropez PLUS £30,000 spending money!"
        canonical='https://www.daymade.co.uk/prizes/details/win-private-yacht'
        openGraph={{
          title: 'DAYMADE | Win A Private Yacht Holiday Worth £100k',
          description: 'Enter our weekly draw for the chance to win 2 weeks for up to 14 people on your own private yacht in St Tropez PLUS £30,000 spending money!',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="Virgin logo against colour-splash background"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer'>
          <Subheading Tag='h1' className='pageTitle'>
            Win A Private Yacht Holiday<br />
            <span style={{ fontSize: '2em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win 2 weeks for up to 14 people on your own private yacht in St Tropez PLUS £30,000 spending money!
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing different parts of a luxury private yacht with a jacuzzi on the back"
        >
          <p>
            What's Jordan Belfort without the shady business tactics and sinking ship? YOU! With this prize, you get the chance to immerse yourself in the filthy rich lifestyle that is usually only a luxury available to the horrible wolfs of Wall Street (& the likes). Pop champagne, enjoy caviar brekkies & organise an extravagant feast every night!
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="couple riding jet-ski behind luxury yacht"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>
              2-weeks yacht hire in St Tropez (max 14 guests - type of Yacht depending on booking dates but all options are exquisite)
            </li>

            <li>
              Professional skipper
            </li>

            <li>
              £30,000 spending money
            </li>

            <li>
              100 bottles of Moët Chandon - cheers, baby!
            </li>
          </ul>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>

      <style jsx>
        {`
          :global(.pageTitleGreenSectionContainer .pageTitle) {
            font-size: 2.1em;
          }
          
          @media(max-width: 500px) {
            :global(.pageTitleGreenSectionContainer .pageTitle) {
              font-size: 1.3em;
            }
          }
        `}
      </style>
    </MainLayout>
  );
};

export default WinAYachtHoliday;
